// @core/api/endpoints/affiliate/list_referral_links.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListReferralLinksResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List referral links
 * Returns a paginated list of referral links. Supports filtering and sorting.
 */
export async function ListReferralLinks(
  params?: PaginatedRequest & {
    affiliate_id?: string | number | boolean;
    campaign_id?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListReferralLinksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/referral-links`;
  const requestOptions = options;
  return client.get<ListReferralLinksResponse>(requestPath, { ...requestOptions, params });
}
